import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLanguage } from "../redux/languageSlice";
import { getText, isRTL } from "../i18n";
import Loader from "../components/Loader";

const Index = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  
  // Força o idioma para pt-AO
  const language = "pt-AO";
  const t = getText(language, "index");
  const common = getText(language, "common");

  const [activeLanguage, setActiveLanguage] = useState(null);
  const [progress, setProgress] = useState(0);
  const [statusText, setStatusText] = useState(t.waiting);
  const timerRef = useRef(null);

  // Inicia o carregamento automaticamente ao montar o componente
  useEffect(() => {
    dispatch(setLanguage(language));
    setActiveLanguage(language);
  }, [dispatch, language]);

  useEffect(() => {
    if (!activeLanguage) return undefined;

    setStatusText(t.loading);
    timerRef.current = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) return 100;
        const next = prev + (prev < 40 ? 4 : prev > 85 ? 6 : 1.5);
        if (next < 30) setStatusText(t.sync);
        else if (next < 60) setStatusText(t.jws);
        else if (next < 85) setStatusText(t.modules);
        else setStatusText(t.ready);
        return next > 100 ? 100 : next;
      });
    }, 120);

    return () => clearInterval(timerRef.current);
  }, [activeLanguage, t]);

  useEffect(() => {
    if (progress !== 100) return undefined;
    const timeout = setTimeout(() => navigate(user ? "/dashboard" : "/login"), 500);
    return () => clearTimeout(timeout);
  }, [progress, navigate, user]);

  return (
    <Loader progress={progress} status={statusText} /> 
  );
};

export default Index;